/**
 * Formats a number as Indonesian Rupiah currency.
 * @param {number|string} value - The value to format
 * @param {object} options - Optional formatting options
 * @returns {string} Formatted currency string (e.g., 'Rp 1.500.000')
 */
export const formatCurrency = (value, options = {}) => {
    if (value === null || value === undefined || value === "") return "-";

    const numValue = typeof value === "string" ? parseFloat(value) : value;

    if (isNaN(numValue)) return "-";

    const defaultOptions = {
        style: "currency",
        currency: "IDR",
        maximumFractionDigits: 0,
    };

    return new Intl.NumberFormat("id-ID", {
        ...defaultOptions,
        ...options,
    }).format(numValue);
};

/**
 * Formats a unit price as Rupiah, showing up to 2 decimals only when present.
 * Useful for prices derived from a line subtotal (e.g. 3 butir Rp 1.000 → 'Rp 333,33').
 * @param {number|string} value - The value to format
 * @returns {string} Formatted currency string (e.g., 'Rp 333,33' or 'Rp 1.000')
 */
export const formatPrice = (value) =>
    formatCurrency(value, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });

/**
 * Formats a number with Indonesian thousand separators.
 * @param {number|string} value - The value to format
 * @returns {string} Formatted number string (e.g., '1.500.000')
 */
export const formatThousands = (value) => {
    if (value === null || value === undefined || value === "") return "-";

    const numValue = typeof value === "string" ? parseFloat(value) : value;

    if (isNaN(numValue)) return "-";

    return new Intl.NumberFormat("id-ID").format(numValue);
};
